/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Sub_GeoInputs */

const cs_property_sub_geo = /** @type {(inputs: Property_Sub_GeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapa a RÚIAN`)
};

const en_property_sub_geo = /** @type {(inputs: Property_Sub_GeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Map & RÚIAN`)
};

/**
* | output |
* | --- |
* | "Map & RÚIAN" |
*
* @param {Property_Sub_GeoInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_sub_geo = /** @type {((inputs?: Property_Sub_GeoInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Sub_GeoInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_sub_geo(inputs)
	return cs_property_sub_geo(inputs)
});